import { Checkbox } from '@pluxee-design-system/core';
import { getCheckBoxValue } from 'common/forms/utils';
import { ComponentProps } from 'components/VirtualizedTable/types';
import { LocationItem } from 'generated/models';
import { get } from 'lodash';
import { ChangeEvent, useCallback } from 'react';
import { useController } from 'react-hook-form';

const LocationProductCell = ({
  row: { editable, location, productStatus },
  extra: isEditable,
}: ComponentProps<LocationItem, boolean, boolean>) => {
  const { field } = useController({ name: 'locations' });
  const { onChange } = field;
  const index = location.uid;
  const hasAssignedProduct = Boolean(productStatus);
  const currentValue = get(field.value, `${index}.newState`, hasAssignedProduct);

  const handleOnChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) =>
      onChange(getCheckBoxValue(hasAssignedProduct, event.target.checked, field.value, index)),
    [field.value, hasAssignedProduct, index, onChange],
  );

  return (
    <Checkbox
      name={`locations.${index}.newState`}
      isDisabled={!editable || !isEditable}
      id={`locations.${index}`}
      isChecked={currentValue}
      onChange={handleOnChange}
    />
  );
};

export default LocationProductCell;
